<template>
  <div class="site-title bg-black p-4">
    <a href="/" title="SPP Application Portal" aria-label="SPP Application Portal">
      <SiteLogoText />
    </a>
  </div>
</template>

<script setup>
import SiteLogoText from './SiteLogoText.vue'
</script>
